import { filter } from 'rxjs/operators';
import { FarmersDetailsService } from './../../../services/farmers-details.service';
import { Component, EventEmitter, OnInit, Output, OnDestroy ,Input} from '@angular/core';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { Observable, Subject, first } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { JEService } from 'src/app/services/je-services.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { JsonPipe } from '@angular/common';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';


@Component({
  selector: 'app-image-attachments',
  templateUrl: './image-attachments.component.html',
  styleUrls: ['./image-attachments.component.scss']
})
export class ImageAttachmentsComponent implements OnInit {

  documentList: any = [];
  autoId: any;
  miPhysicalAppReqBody: any;
  appId: any;
  listImagePathJE: any;
  listImagePathXEN: any;
  miPhysicalApplicationData: any;
  showListImageJE: boolean = true;
  showListImageXEN: boolean = true;
  activeIndex: number = 0;
  displayCustomJE: boolean;
  displayCustomXEN: boolean;
  displayCustom: boolean;
  images = [];
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  constructor( private messageService: MessageService, private route: ActivatedRoute, private router: Router, private cryptoJsService: CryptoJsService, private deptDashBoardService: DepartmentDashboardService,private loader: AppLoaderService, private activityRecordService: ActivityRecordService) { }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.autoId = this.cryptoJsService.DecryptData(params.autoId);
        this.appId = this.cryptoJsService.DecryptData(params.appId);
        if (this.appId) {
          if (JSON.parse(sessionStorage.getItem('documentList'))?.appId == this.appId) {
            this.documentList = JSON.parse(sessionStorage.getItem('documentList'))?.documentList;
          }
          // if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))?.length)) {
          //   if ((JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'))[0]?.appID) == this.appId) {
          //     this.miPhysicalAppReqBody = JSON.parse(sessionStorage.getItem('miPhysicalAppReqBody'));
          //   } else {
          //     this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
          //     setTimeout(() => {
          //       this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
          //       return;
          //     }, 1000);
          //   }

          // } else {
          //   this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Please Save Finace Data to continue!' });
          //   setTimeout(() => {
          //     this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
          //     return;
          //   }, 1000);
          // }

        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be empty' });
          return;
        }
      }
      );
      this.miPhysicalApplicationData = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));
      console.log("miPhysicalApplicationData", this.miPhysicalApplicationData);
      

      if(this.miPhysicalApplicationData?.listDataForPhysicalVer){ 
        for (let index = 0; index < this.miPhysicalApplicationData?.listDataForPhysicalVer.length; index++) {
          if(this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory!=null && this.miPhysicalApplicationData.listDataForPhysicalVer[index].inventory.length>0){
            delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedQuantity;
            delete this.miPhysicalApplicationData.listDataForPhysicalVer[index].selectedInventory;
          }
        }        
      }
      if(sessionStorage.getItem('isJE')){
        this.showListImageJE = false;
        this.showListImageXEN = false;
        this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
      }
      else if(sessionStorage.getItem('isXEN')){
        this.showListImageXEN = false;
        this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE
        this.documentList = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
      }
      else{
        this.listImagePathJE = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathJE;
        this.listImagePathXEN = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.listImagePathXEN;
      }

  }
  onImageFormSubmit(){
    this.images = this.documentList;
    this.route.queryParams
      .subscribe(params => {
        if (params.autoId) {
          this.router.navigate([this.router.url.split('/')[1], 'application', 'finance'], { queryParams: { autoId: params.autoId, appId: params.appId } });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
        }
      }
      );
  }
  onImageFormGoBack(){
    this.route.queryParams.subscribe((params) => {
      if (params.autoId) {
        this.router.navigate(
          [this.router.url.split('/')[1], 'application', 'basic'],
          { queryParams: { autoId: params.autoId, appId: params.appId } }
        );
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! AutoID cant be Empty',
        });
      }
    });
  }
  imageClick(index: number, type) {
    this.activeIndex = index;
    if(type == "JE"){
      this.displayCustomJE = true;
    }
    else if(type == "XEN"){
      this.displayCustomXEN = true;
    }
    else if(type == "PA"){
      this.displayCustom = true;
    }
  }
}
